
import React, { useEffect, useState } from 'react'

export function ClientOnly({ fallback, component, props, children, refItem }) {
    const [Component, setComponent] = React.useState(null)

    React.useEffect(() => {
        setComponent(() => React.lazy(component))
    }, [])
    const renderComponent = () => {
        if (!Component) {
            return fallback?.() || <></>
        }
        const cProps = { ...props, children }
        return <Component {...cProps} ref={refItem} />
    }
    return renderComponent()
}
export const useClient = () => {
    const [client, setClient] = useState(false)
    useEffect(() => {
        setClient(true)
    }, [])

    return client
}